import React from 'react';

export default function HopperIcon({
  width = 64,
  height = 64,
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) {
  const id = Math.random().toString(36).slice(2, 9);
  return (
    <svg width={width} height={height} viewBox="0 0 112.5 112.5" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <filter id={`fp-shadow-${id}`} x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.5"/>
          <feOffset dx="0" dy="3" result="offsetblur"/>
          <feComponentTransfer><feFuncA type="linear" slope="0.45"/></feComponentTransfer>
          <feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>
        </filter>
        <radialGradient id={`fp-shine-${id}`} cx="35%" cy="22%" r="65%">
          <stop offset="0%" stopColor="rgba(255,255,255,0.28)"/>
          <stop offset="55%" stopColor="rgba(255,255,255,0.06)"/>
          <stop offset="100%" stopColor="rgba(255,255,255,0)"/>
        </radialGradient>
      </defs>
      <g filter={`url(#fp-shadow-${id})`}>
      <g id="Group_TankBody">
<linearGradient id={`${id}_1_`} gradientUnits="userSpaceOnUse" x1="42.1182" y1="106.4609" x2="70.3818" y2="106.4609">
	<stop offset="0" style={{stopColor: "#373737"}} />
	<stop offset="0.11" style={{stopColor: "#686868"}} />
	<stop offset="0.24" style={{stopColor: "#A0A0A0"}} />
	<stop offset="0.36" style={{stopColor: "#C8C8C8"}} />
	<stop offset="0.45" style={{stopColor: "#E1E1E1"}} />
	<stop offset="0.5" style={{stopColor: "#EBEBEB"}} />
	<stop offset="0.56" style={{stopColor: "#E3E3E3"}} />
	<stop offset="0.64" style={{stopColor: "#CECECE"}} />
	<stop offset="0.74" style={{stopColor: "#ACACAC"}} />
	<stop offset="0.86" style={{stopColor: "#7D7D7D"}} />
	<stop offset="0.98" style={{stopColor: "#414141"}} />
	<stop offset="1" style={{stopColor: "#373737"}} />
</linearGradient>
<path fill={`url(#${id}_1_)`} d="M42.118,100.423V112.5h28.264v-12.077H42.118z" />
<linearGradient id={`${id}_2_`} gradientUnits="userSpaceOnUse" x1="0" y1="86.1758" x2="112.5" y2="86.1758">
	<stop offset="0.07" style={{stopColor: "#373737"}} />
	<stop offset="0.49" style={{stopColor: "#EBEBEB"}} />
	<stop offset="0.55" style={{stopColor: "#D8D8D8"}} />
	<stop offset="0.67" style={{stopColor: "#A7A7A7"}} />
	<stop offset="0.84" style={{stopColor: "#595959"}} />
	<stop offset="0.91" style={{stopColor: "#373737"}} />
</linearGradient>
<path fill={`url(#${id}_2_)`} d="M0,70.382l42.118,31.589h28.264L112.5,70.382H0z" />
<linearGradient id={`${id}_3_`} gradientUnits="userSpaceOnUse" x1="0" y1="42.1182" x2="112.5" y2="42.1182">
	<stop offset="0" style={{stopColor: "#373737"}} />
	<stop offset="0.5" style={{stopColor: "#EBEBEB"}} />
	<stop offset="0.57" style={{stopColor: "#D8D8D8"}} />
	<stop offset="0.71" style={{stopColor: "#A7A7A7"}} />
	<stop offset="0.92" style={{stopColor: "#595959"}} />
	<stop offset="1" style={{stopColor: "#373737"}} />
</linearGradient>
<path fill={`url(#${id}_3_)`} d="M112.5,6.927H0v63.455h0l0,0.001c0,2.652,30,6.926,56.25,6.926c26.5,0,56.25-4.273,56.25-6.926  v-0.001l0,0V6.927z" />
<linearGradient id={`${id}_4_`} gradientUnits="userSpaceOnUse" x1="56.2495" y1="0" x2="56.2495" y2="14.1318">
	<stop offset="0" style={{stopColor: "#C7C7C7"}} />
	<stop offset="0.29" style={{stopColor: "#B0B0B0"}} />
	<stop offset="0.91" style={{stopColor: "#747474"}} />
	<stop offset="1" style={{stopColor: "#6B6B6B"}} />
</linearGradient>
<path fill={`url(#${id}_4_)`} d="M56.25,0c31.066,0,56.25,3.102,56.25,6.927s-25.184,7.205-56.25,7.205  C25.184,14.132,0,10.753,0,6.927S25.184,0,56.25,0z" />
</g>
    
      </g>
      <rect x="0" y="0" width="112.5" height="112.5" fill={`url(#fp-shine-${id})`} style={{pointerEvents:"none"}}/>
    </svg>
  );
}
